/**
 * Formats a number to include commas.
 *
 * Jacked from stackoverflow: http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
 *
 * @param {String|Number} num
 * @returns {String}
 */
export const formatNumber = function (num) {
  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};
